import { JSONObject } from '@lucidtech/las-sdk-browser';
import { useCallback, useEffect, useState } from 'react';

import { REFETCH_AGENT_RUN_INTERVAL } from '@/constants';
import { isArray } from '@/utils';

import { toAgentRunId, toFileId, useGetAgentRun, useGetFile } from './api';

export type UseGetAgentRunVariablestOpts = {
  agentId?: string | null;
  runId?: string | null;
};

export const useGetAgentRunVariables = ({ agentId, runId }: UseGetAgentRunVariablestOpts) => {
  const { data: agentRun } = useGetAgentRun(toAgentRunId(agentId, runId), {
    fetchFromListCache: true,
    refetchInterval: REFETCH_AGENT_RUN_INTERVAL,
  });

  const { data: blob } = useGetFile(toFileId(agentRun?.variablesFileUrl));
  const [variables, setVariables] = useState<JSONObject | undefined>();

  useEffect(() => {
    if (blob) {
      blob.text().then((result) => {
        setVariables(JSON.parse(result));
      });
    }
  }, [agentRun, blob]);

  const get = useCallback(
    (key: string) => {
      if (variables && key in variables) {
        const obj = variables[key];
        if (typeof obj === 'object' && !isArray(obj)) {
          return obj?.value;
        } else {
          return obj;
        }
      }
    },
    [variables]
  );

  return { get, variables };
};
